// Fades its content up into view the first time it scrolls on screen.
// Content stays visible if this script never runs, because hiding is only armed here.
class RevealElement extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    this.dataset.armed = '';
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.dataset.revealed = '';
          this.#observer?.disconnect();
        }
      },
      { threshold: 0.12 },
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-reveal')) {
  customElements.define('s-reveal', RevealElement);
}
